<template>
  <main class="p-4 pt-16 lg:pt-16">
    <section v-if="furniture"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10" class="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4 items-start">
      <div
        v-for="item in furniture.data"
        :key="item.uid"
        @mouseenter="pageTitle(item.title); $root.$emit('changeCursor', '&#x25C6;')"
        @mouseleave="pageTitle(''); $root.$emit('resetCursor')"
        @click="pushed = true"
        class="relative w-full sb-thumb" 
      >
        <router-link :to="{ name: 'item', params: { id: item.uid } }" class="sb-thumbinside">
          <img class="lazyload absolute top-0 left-0 w-full h-full object-cover mix-blend-multiply" v-lazy="item.image.thumb" :data-srcset="item.image.srcset" :alt="item.title" />
        </router-link>
      </div>
      <div v-if="busy" class="p-4 text-center">Loading more</div>
    </section>
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "furniture",
  metaInfo: {
    title: "– Furniture",
  },
  data() {
    return {
      busy: false,
      pushed: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.$root.$emit('pageTitle', '');
      this.$root.$emit('imgCounter', '');
    }, 0);
  },
  computed: mapState(["furniture"]),
  methods: {
    loadMore() {
      this.busy = true;
      let curPage = this.furniture.pagination.page;
      if (curPage < this.furniture.pagination.pages) {
        this.$store.dispatch("loadFurniture", curPage + 1).then(() => {
          this.busy = false;
        });
      } else {
        this.busy = false;
      }
    },
    pageTitle(title) {
      if(!this.pushed) {
        this.$root.$emit('pageTitle', title);
      }
    }
  },
};
</script>
